module.exports = __webpack_public_path__ + "static/media/cricket.89dbf145.JPG";